import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
export var ShopPaymentProvider = function (_a) {
    var provider = _a.provider, onClick = _a.onClick, isSelected = _a.isSelected;
    var countryCode = ("" + provider.countryCode).toLowerCase();
    var providerClass = "payment-provider-logo provider-" + provider.id + " country-" + countryCode;
    var className = isSelected ? "selected" : "";
    return (React.createElement("div", { className: IdStyles.ShopPaymentProviderItem + " " + className + " shop-psp__provider ", title: provider.translation, onClick: function () { return onClick(provider); } },
        React.createElement("div", { className: providerClass }),
        React.createElement("span", { className: IdStyles.TextVerySmall + " shop-psp__provider-name" }, provider.translation)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/ShopPaymentProvider.tsx
// module id = 2924
// module chunks = 3